export const classifyLists = [
    {
      label: '自定义',
      value: '10'
    },
    {
      label: '美食',
      value: '100000',
      children: [
        {
          label: '中餐厅',
          value: '101000',
          children: [
            {
              label: '北京菜',
              value: '101010'
            },
            {
              label: '安徽菜',
              value: '101011'
            },
            {
              label: '山西菜',
              value: '101012'
            },
            {
              label: '福建菜',
              value: '101013'
            },
            {
              label: '河南菜',
              value: '101014'
            },
            {
              label: '鲁菜',
              value: '101015'
            },
            {
              label: '川菜',
              value: '101016'
            },
            {
              label: '湘菜',
              value: '101017'
            },
            {
              label: '湖北菜',
              value: '101018'
            },
            {
              label: '淮扬菜',
              value: '101019'
            },
            {
              label: '浙江菜',
              value: '101020'
            },
            {
              label: '上海菜',
              value: '101021'
            },
            {
              label: '南京菜',
              value: '101022'
            },
            {
              label: '苏州菜',
              value: '101023'
            },
            {
              label: '粤菜',
              value: '101024'
            },
            {
              label: '东北菜',
              value: '101025'
            },
            {
              label: '新疆菜',
              value: '101027'
            },
            {
              label: '西北菜',
              value: '101028'
            },
            {
              label: '云贵菜',
              value: '101029'
            },
            {
              label: '民族菜',
              value: '101030'
            },
            {
              label: '台湾菜',
              value: '101031'
            },
            {
              label: '天津菜',
              value: '101032'
            },
            {
              label: '江苏菜',
              value: '101033'
            },
            {
              label: '酒楼',
              value: '101034'
            },
            {
              label: '其它中餐厅',
              value: '101099'
            },
          ]
        },
        {
          label: '农家菜',
          value: '101100'
        },
        {
          label: '官府菜',
          value: '101200'
        },
        {
          label: '家常菜',
          value: '101300'
        },
        {
          label: '私家菜',
          value: '101400'
        },
        {
          label: '烧烤',
          value: '101500'
        },
        {
          label: '火锅',
          value: '101600'
        },
        {
          label: '海鲜',
          value: '101700'
        },
        {
          label: '特色中餐',
          value: '101800'
        },
        {
          label: '素食',
          value: '101900'
        },
        {
          label: '小吃快餐',
          value: '102000'
        },
        {
          label: '清真',
          value: '102100'
        },
        {
          label: '日韩菜',
          value: '102200',
          children: [
            {
              label: '日本料理',
              value: '102210'
            },
            {
              label: '韩国料理',
              value: '102211'
            },
            {
              label: '其它日韩菜',
              value: '102299'
            },
          ]
        },
        {
          label: '东南亚菜',
          value: '102300',
          children: [
            {
              label: '印度菜',
              value: '102310'
            },
            {
              label: '星马菜',
              value: '102311'
            },
            {
              label: '泰国菜',
              value: '102312'
            },
            {
              label: '越南菜',
              value: '102313'
            },
            {
              label: '其它东南亚菜',
              value: '102399'
            },
          ]
        },
        {
          label: '西餐',
          value: '102400',
          children: [
            {
              label: '美国菜',
              value: '102410'
            },
            {
              label: '葡国菜',
              value: '102411'
            },
            {
              label: '俄罗斯菜',
              value: '102412'
            },
            {
              label: '地中海菜',
              value: '102413'
            },
            {
              label: '意大利菜',
              value: '102414'
            },
            {
              label: '巴西菜',
              value: '102415'
            },
            {
              label: '拉美烧烤',
              value: '102416'
            },
            {
              label: '比萨',
              value: '102417'
            },
            {
              label: '法国菜',
              value: '102418'
            },
            {
              label: '牛排',
              value: '102419'
            },
            {
              label: '英国菜',
              value: '102420'
            },
            {
              label: '德国菜',
              value: '102421'
            },
            {
              label: '墨西哥菜',
              value: '102423'
            },
            {
              label: '其它西餐',
              value: '102499'
            },
          ]
        },
        {
          label: '自助餐',
          value: '102500'
        },
        {
          label: '面包甜点',
          value: '102600'
        },
        {
          label: '茶餐厅',
          value: '102700'
        },
        {
          label: '冷饮店',
          value: '102800'
        },
        {
          label: '美食场所附属',
          value: '103000'
        },
        {
          label: '其它美食',
          value: '109900'
        },
      ]
    },
    {
      label: '公司企业',
      value: '110000',
      children: [
        {
          label: '公司企业',
          value: '111000'
        },
        {
          label: '农林牧渔基地',
          value: '111100'
        },
        {
          label: '企业/工厂',
          value: '111200'
        },
        {
          label: '其它公司企业',
          value: '119900'
        },
      ]
    },
    {
      label: '机构团体',
      value: '120000',
      children: [
        {
          label: '公检法机构',
          value: '121000'
        },
        {
          label: '外国机构',
          value: '121100'
        },
        {
          label: '工商税务机构',
          value: '121200'
        },
        {
          label: '政府机关',
          value: '121400'
        },
        {
          label: '民主党派',
          value: '121500'
        },
        {
          label: '社会团体',
          value: '121600'
        },
        {
          label: '传媒机构',
          value: '121700'
        },
        {
          label: '文艺团体',
          value: '121800'
        },
        {
          label: '科研机构',
          value: '121900'
        },
        {
          label: '机构团体附属',
          value: '128000'
        },
        {
          label: '其它机构团体',
          value: '129900'
        },
      ]
    },
    {
      label: '购物',
      value: '130000',
      children: [
        {
          label: '综合商场',
          value: '131000',
          children: [
            {
              label: '购物中心',
              value: '131010'
            },
          ]
        },
        {
          label: '便利店',
          value: '131100'
        },
        {
          label: '超市',
          value: '131200'
        },
        {
          label: '数码家电',
          value: '131300'
        },
        {
          label: '花鸟鱼虫',
          value: '131400'
        },
        {
          label: '家具家居建材',
          value: '131500',
          children: [
            {
              label: '家具家居',
              value: '131510'
            },
            {
              label: '建材',
              value: '131511'
            },
            {
              label: '灯具用品',
              value: '131512'
            },
            {
              label: '卫浴用品',
              value: '131513'
            },
            {
              label: '厨房用品',
              value: '131514'
            },
            {
              label: '五金用品',
              value: '131515'
            },
          ]
        },
        {
          label: '农贸市场',
          value: '131600'
        },
        {
          label: '小商品市场',
          value: '131700'
        },
        {
          label: '旧货市场',
          value: '131800'
        },
        {
          label: '体育户外',
          value: '131900'
        },
        {
          label: '服饰鞋包',
          value: '132000',
          children: [
            {
              label: '服装',
              value: '132010'
            },
            {
              label: '鞋店',
              value: '132011'
            },
            {
              label: '箱包',
              value: '132012'
            },
  
          ]
        },
        {
          label: '图书音像',
          value: '132100'
        },
        {
          label: '眼镜店',
          value: '132200'
        },
        {
          label: '母婴儿童',
          value: '132300'
        },
        {
          label: '珠宝饰品',
          value: '132400',
          children: [
            {
              label: '珠宝',
              value: '132410'
            },
            {
              label: '饰品',
              value: '132411'
            },
          ]
        },
        {
          label: '化妆品',
          value: '132500'
        },
        {
          label: '商业步行街',
          value: '132600'
        },
        {
          label: '礼品',
          value: '132700'
        },
        {
          label: '摄影器材',
          value: '132800'
        },
        {
          label: '钟表店',
          value: '132900'
        },
        {
          label: '拍卖典当行',
          value: '133000'
        },
        {
          label: '古玩字画',
          value: '133100'
        },
        {
          label: '自行车专卖',
          value: '133200'
        },
        {
          label: '烟酒专卖',
          value: '133300'
        },
        {
          label: '文化用品',
          value: '133400'
        },
        {
          label: '乐器',
          value: '133500'
        },
        {
          label: '免税店',
          value: '133600'
        },
        {
          label: '购物场所附属',
          value: '138000',
          children: [
            {
              label: '购物篮/车放置区',
              value: '138010'
            },
            {
              label: '人工收银/服务台',
              value: '138011'
            },
            {
              label: '人工收银',
              value: '138024'
            },
            {
              label: '服务台',
              value: '138025'
            },
            {
              label: '自助购物',
              value: '138012'
            },
            {
              label: '熟食/面包',
              value: '138013'
            },
            {
              label: '个人护理',
              value: '138014'
            },
            {
              label: '家居用品',
              value: '138015'
            },
            {
              label: '食品饮料',
              value: '138016'
            },
            {
              label: '果蔬',
              value: '138017'
            },
            {
              label: '杂粮干货',
              value: '138018'
            },
            {
              label: '海鲜/肉类',
              value: '138019'
            },
            {
              label: '加工坊',
              value: '138020'
            },
            {
              label: '乳制品',
              value: '138021'
            },
            {
              label: '冷冻食品',
              value: '138022'
            },
            {
              label: '母婴用品',
              value: '138023'
            },
          ]
        },
        {
          label: '其它购物',
          value: '139900'
        },
      ]
    },
    {
      label: '生活服务',
      value: '140000',
      children: [
        {
          label: '旅行社',
          value: '141000'
        },
        {
          label: '票务代售',
          value: '141100',
          children: [
            {
              label: '飞机票代售',
              value: '141110'
            },
            {
              label: '火车票代售',
              value: '141111'
            },
            {
              label: '汽车票代售',
              value: '141112'
            },
            {
              label: '公交及IC卡',
              value: '141113'
            },
            {
              label: '景点售票',
              value: '141114'
            },
            {
              label: '其它票务代售',
              value: '141199'
            },
          ]
        },
        {
          label: '邮局速递',
          value: '141200',
          children: [
            {
              label: '邮局',
              value: '141210'
            },
            {
              label: '速递',
              value: '141211'
            },
            {
              label: '物流公司',
              value: '141212'
            },
            {
              label: '物流仓储场地',
              value: '141213'
            },
            {
              label: '其它邮局速递',
              value: '141299'
            },
          ]
        },
        {
          label: '通讯服务',
          value: '141300',
          children: [
            {
              label: '中国电信营业厅',
              value: '141310'
            },
            {
              label: '中国网通营业厅',
              value: '141311'
            },
            {
              label: '中国移动营业厅',
              value: '141312'
            },
            {
              label: '中国联通营业厅',
              value: '141313'
            },
            {
              label: '中国铁通营业厅',
              value: '141314'
            },
            {
              label: '其它通讯服务',
              value: '141399'
            },
  
          ]
        },
        {
          label: '报刊亭',
          value: '141400'
        },
        {
          label: '自来水营业厅',
          value: '141500'
        },
        {
          label: '电力营业厅',
          value: '141600'
        },
        {
          label: '摄影冲印',
          value: '141700'
        },
        {
          label: '洗衣店',
          value: '141800'
        },
        {
          label: '教练',
          value: '142000'
        },
        {
          label: '生活服务场所',
          value: '142100'
        },
        {
          label: '信息咨询中心',
          value: '142200'
        },
        {
          label: '招聘求职',
          value: '142300'
        },
        {
          label: '彩票',
          value: '142400',
          children: [
            {
              label: '彩票彩券销售点',
              value: '142410'
            },
            {
              label: '马会投注站',
              value: '142411'
            },
          ]
        },
        {
          label: '事务所',
          value: '142500',
        },
        {
          label: '家政',
          value: '142600',
          children: [
            {
              label: '月嫂保姆',
              value: '142610'
            },
            {
              label: '保洁钟点工',
              value: '142611'
            },
            {
              label: '开锁',
              value: '142612'
            },
            {
              label: '送水',
              value: '142613'
            },
            {
              label: '家电维修',
              value: '142614'
            },
            {
              label: '管道疏通打孔',
              value: '142615'
            },
            {
              label: '搬家',
              value: '142616'
            },
            {
              label: '其它家政',
              value: '142699'
            },
          ]
        },
        {
          label: '中介机构',
          value: '142700'
        },
        {
          label: '宠物服务',
          value: '142800',
          children: [
            {
              label: '宠物商店',
              value: '142810'
            },
            {
              label: '宠物市场',
              value: '142811'
            },
            {
              label: '宠物医院',
              value: '142812'
            },
            {
              label: '其它宠物服务',
              value: '142899'
            },
          ]
        },
        {
          label: '丧葬',
          value: '142900'
        },
        {
          label: '废品收购站',
          value: '143000'
        },
        {
          label: '福利院养老院',
          value: '143100'
        },
        {
          label: '测字风水',
          value: '143200'
        },
        {
          label: '婚庆服务',
          value: '143300'
        },
        {
          label: '美容美发',
          value: '143400',
          children: [
            {
              label: '美发',
              value: '143410'
            },
            {
              label: '美容SPA',
              value: '143411'
            },
            {
              label: '瘦身纤体',
              value: '143412'
            },
            {
              label: '美甲',
              value: '143413'
            },
            {
              label: '其它美容美发',
              value: '143499'
            },
          ]
        },
        {
          label: '装修',
          value: '143500'
        },
        {
          label: '生活服务附属',
          value: '143700',
          children: [
            {
              label: '自动售货机',
              value: '143710'
            },
            {
              label: '自助缴费终端',
              value: '143711'
            },
            {
              label: '母婴室',
              value: '143712'
            },
            {
              label: '休息室',
              value: '143713'
            },
            {
              label: '茶水间',
              value: '143714'
            },
            {
              label: '商务服务',
              value: '143715'
            },
            {
              label: '物业管理',
              value: '143716'
            },
            {
              label: '手机充电处',
              value: '143717'
            },
          ]
        },
        {
          label: '其它生活服务',
          value: '149900'
        },
  
      ]
    },
    {
      label: '娱乐休闲',
      value: '160000',
      children: [
        {
          label: '洗浴推拿足疗',
          value: '161000',
          children: [
            {
              label: '洗浴',
              value: '161010'
            },
            {
              label: '按摩',
              value: '161011'
            },
            {
              label: '推拿',
              value: '161012'
            },
            {
              label: '足疗',
              value: '161013'
            },
            {
              label: '修脚',
              value: '161014'
            },
          ]
        },
        {
          label: 'KTV',
          value: '161100'
        },
        {
          label: '酒吧',
          value: '161200'
        },
        {
          label: '咖啡厅',
          value: '161300'
        },
        {
          label: '夜总会',
          value: '161400'
        },
        {
          label: '茶馆',
          value: '161500'
        },
        {
          label: '电影院',
          value: '161600'
        },
        {
          label: '剧场音乐厅',
          value: '161700',
          children: [
            {
              label: '剧场',
              value: '161710'
            },
            {
              label: '音乐厅',
              value: '161711'
            },
            {
              label: '其它剧场音乐厅',
              value: '161799'
            },
  
          ]
        },
        {
          label: '度假疗养',
          value: '161800'
        },
        {
          label: '户外活动',
          value: '161900',
          children: [
            {
              label: '游乐场',
              value: '161910'
            },
            {
              label: '拓展培训',
              value: '161911'
            },
            {
              label: '垂钓园',
              value: '161912'
            },
            {
              label: '采摘园',
              value: '161913'
            },
            {
              label: '露营地',
              value: '161914'
            },
            {
              label: '水上活动中心',
              value: '161915'
            },
            {
              label: '其它户外活动',
              value: '161999'
            },
  
          ]
        },
        {
          label: '游戏棋牌',
          value: '162000',
          children: [
            {
              label: '游戏厅',
              value: '162010'
            },
            {
              label: '棋牌室',
              value: '162011'
            },
            {
              label: '桌面游戏',
              value: '162012'
            },
            {
              label: '博彩中心',
              value: '162013'
            },
            {
              label: '其它游戏棋牌',
              value: '162099'
            },
          ]
        },
        {
          label: '网吧',
          value: '162100'
        },
        {
          label: '迪厅',
          value: '162200'
        },
        {
          label: '亲子',
          value: '162300'
        },
        {
          label: '娱乐休闲场所附属',
          value: '168000',
          children: [
            {
              label: '影剧院设施',
              value: '168010'
            },
          ]
        },
        {
          label: '其它娱乐休闲',
          value: '169900'
        },
      ]
    },
    {
      label: '运动健身',
      value: '180000',
      children: [
        {
          label: '健身中心',
          value: '181000'
        },
        {
          label: '游泳馆',
          value: '181100'
        },
        {
          label: '海滨浴场',
          value: '181200'
        },
        {
          label: '瑜伽',
          value: '181300'
        },
        {
          label: '羽毛球馆',
          value: '181400'
        },
        {
          label: '乒乓球馆',
          value: '181500'
        },
        {
          label: '网球场',
          value: '181600'
        },
        {
          label: '篮球场',
          value: '181700'
        },
        {
          label: '足球场',
          value: '181800'
        },
        {
          label: '壁球场',
          value: '181900'
        },
        {
          label: '橄榄球',
          value: '182000'
        },
        {
          label: '马术',
          value: '182100'
        },
        {
          label: '赛马场',
          value: '182200'
        },
        {
          label: '高尔夫场',
          value: '182300'
        },
        {
          label: '保龄球馆',
          value: '182400'
        },
        {
          label: '台球馆',
          value: '182500'
        },
        {
          label: '滑雪',
          value: '182600'
        },
        {
          label: '溜冰',
          value: '182700'
        },
        {
          label: '跆拳道',
          value: '182800'
        },
        {
          label: '舞蹈',
          value: '182900'
        },
        {
          label: '综合体育场馆',
          value: '183000',
          children: [
            {
              label: '运动保健服务',
              value: '183010'
            },
            {
              label: '普通观众服务',
              value: '183020'
            },
            {
              label: 'VIP观众服务',
              value: '183030'
            },
            {
              label: '看台',
              value: '183040'
            },
            {
              label: '其他附属设施',
              value: '183050'
            },
          ]
        },
        {
          label: '运动健身场所附属',
          value: '188000'
        },
        {
          label: '其它运动健身',
          value: '189900'
        },
      ]
    },
    {
      label: '汽车',
      value: '190000',
      children: [
        {
          label: '加油站',
          value: '191000',
          children: [
            {
              label: '中石化',
              value: '191010'
            },
            {
              label: '中石油',
              value: '191011'
            },
            {
              label: '加油加气站',
              value: '191012'
            },
            {
              label: '加气站',
              value: '191013'
            },
            {
              label: '充电站',
              value: '191014'
            },
            {
              label: '其它加油站',
              value: '191099'
            },
          ]
        },
        {
          label: '停车场',
          value: '191100'
        },
        {
          label: '停车场设施',
          value: '192500',
          children: [
            {
              label: '停车缴费处',
              value: '192510'
            },
            {
              label: '充电停车位',
              value: '192511'
            },
            {
              label: '小客车停车位',
              value: '192512'
            },
            {
              label: '其它停车位',
              value: '192513'
            },
            {
              label: '机器人泊车点',
              value: '192515'
            },
            {
              label: '网约车上车点',
              value: '192516'
            },
          ]
        },
        {
          label: '汽车销售',
          value: '191200'
        },
        {
          label: '汽车维修',
          value: '191300'
        },
        {
          label: '摩托车',
          value: '191400',
          children: [
            {
              label: '摩托车服务相关',
              value: '191410'
            },
            {
              label: '销售',
              value: '191411'
            },
            {
              label: '维修',
              value: '191412'
            },
            {
              label: '其它摩托车',
              value: '191499'
            },
          ]
        },
        {
          label: '驾校',
          value: '191500'
        },
        {
          label: '汽车租赁',
          value: '191600'
        },
        {
          label: '汽车养护',
          value: '191700'
        },
        {
          label: '洗车场',
          value: '191800'
        },
        {
          label: '汽车俱乐部',
          value: '191900'
        },
        {
          label: '汽车救援',
          value: '192000'
        },
        {
          label: '汽车配件销售',
          value: '192100'
        },
        {
          label: '二手车交易市场',
          value: '192200'
        },
        {
          label: '车辆管理机构',
          value: '192400'
        },
        {
          label: '其它汽车',
          value: '199900'
        },
      ]
    },
    {
      label: '医疗保健',
      value: '200000',
      children: [
        {
          label: '综合医院',
          value: '201000'
        },
        {
          label: '专科医院',
          value: '201100',
          children: [
            {
              label: '齿科',
              value: '201110'
            },
            {
              label: '整形',
              value: '201111'
            },
            {
              label: '眼科',
              value: '201112'
            },
            {
              label: '耳鼻喉',
              value: '201113'
            },
            {
              label: '胸科',
              value: '201114'
            },
            {
              label: '骨科',
              value: '201115'
            },
            {
              label: '肿瘤',
              value: '201116'
            },
            {
              label: '脑科',
              value: '201117'
            },
            {
              label: '妇产科',
              value: '201118'
            },
            {
              label: '儿科',
              value: '201119'
            },
            {
              label: '传染病医院',
              value: '201121'
            },
            {
              label: '精神病医院',
              value: '201122'
            },
            {
              label: '其它专科医院',
              value: '201199'
            },
  
          ]
        },
        {
          label: '诊所',
          value: '201200'
        },
        {
          label: '急救中心',
          value: '201300'
        },
        {
          label: '药房药店',
          value: '201400'
        },
        {
          label: '疾病预防',
          value: '201500'
        },
        {
          label: '体检',
          value: '201600'
        },
        {
          label: '卫生院',
          value: '201700'
        },
        {
          label: '社区医院',
          value: '201800'
        },
        {
          label: 'AED',
          value: '201900'
        },
        {
          label: '医疗保健附属',
          value: '208000',
          children: [
            {
              label: '门诊部',
              value: '208010'
            },
            {
              label: '急诊',
              value: '208011'
            },
            {
              label: '挂号/收费/办卡/手续',
              value: '208012'
            },
            {
              label: '护士台/分诊台/信息台',
              value: '208013'
            },
            {
              label: '科室',
              value: '208014'
            },
            {
              label: '手术室',
              value: '208015'
            },
            {
              label: '病房',
              value: '208016'
            },
            {
              label: '监护室',
              value: '208017'
            },
            {
              label: '药房',
              value: '208018'
            },
            {
              label: '检查类',
              value: '208019'
            },
            {
              label: '住院类',
              value: '208020'
            },
            {
              label: '自助挂号/缴费/查询',
              value: '208021'
            },
            {
              label: '诊室',
              value: '208022'
            },
            {
              label: '其它医疗保健附属',
              value: '208099'
            },
          ]
        },
        {
          label: '其它医疗保健',
          value: '209900'
        },
      ]
    },
    {
      label: '酒店宾馆',
      value: '210000',
      children: [
        {
          label: '酒店宾馆',
          value: '211000'
        },
        {
          label: '星级酒店',
          value: '211100'
        },
        {
          label: '经济型酒店',
          value: '211500'
        },
        {
          label: '公寓式酒店',
          value: '211600'
        },
        {
          label: '旅馆招待所',
          value: '211700'
        },
        {
          label: '度假村',
          value: '211800'
        },
        {
          label: '农家院',
          value: '211900'
        },
        {
          label: '青年旅社',
          value: '212000'
        },
        {
          label: '酒店宾馆附属',
          value: '218000'
        },
        {
          label: '其它酒店宾馆',
          value: '219900'
        },
      ]
    },
    {
      label: '旅游景点',
      value: '220000',
      children: [
        {
          label: '风景名胜',
          value: '221000'
        },
        {
          label: '公园',
          value: '221100'
        },
        {
          label: '植物园',
          value: '221200'
        },
        {
          label: '动物园',
          value: '221300'
        },
        {
          label: '水族馆',
          value: '221400'
        },
        {
          label: '城市广场',
          value: '221500'
        },
        {
          label: '世界遗产',
          value: '221600'
        },
        {
          label: '国家级景点',
          value: '221700'
        },
        {
          label: '省级景点',
          value: '221800'
        },
        {
          label: '纪念馆',
          value: '221900'
        },
        {
          label: '寺庙道观',
          value: '222000'
        },
        {
          label: '教堂',
          value: '222100'
        },
        {
          label: '海滩',
          value: '222200'
        },
        {
          label: '清真寺',
          value: '222310'
        },
        {
          label: '景点公园附属',
          value: '228000'
        },
        {
          label: '其它旅游景点',
          value: '229900'
        },
      ]
    },
    {
      label: '文化场馆',
      value: '230000',
      children: [
        {
          label: '博物馆',
          value: '231000'
        },
        {
          label: '展览馆',
          value: '231100'
        },
        {
          label: '科技馆',
          value: '231200'
        },
        {
          label: '图书馆',
          value: '231300',
          children: [
            {
              label: '儿童图书馆',
              value: '231310'
            },
          ]
        },
        {
          label: '天文馆',
          value: '231400'
        },
        {
          label: '档案馆',
          value: '231500'
        },
        {
          label: '文化宫',
          value: '231600'
        },
        {
          label: '美术馆',
          value: '231700'
        },
        {
          label: '会展中心',
          value: '231800',
          children: [
            {
              label: '展馆/展厅',
              value: '231810'
            },
            {
              label: '展区',
              value: '231811'
            },
            {
              label: '展位',
              value: '231812'
            },
            {
              label: '其他会展设施',
              value: '231813'
            },
          ]
        },
        {
          label: '文化场馆附属',
          value: '231900',
          children: [
            {
              label: '展馆/展厅',
              value: '231910'
            },
            {
              label: '展区',
              value: '231911'
            },
            {
              label: '展位',
              value: '231912'
            },
            {
              label: '其他会展设施',
              value: '231913'
            },
          ]
        },
        {
          label: '其它文化场馆',
          value: '239900'
        },
  
      ]
    },
    {
      label: '教育学校',
      value: '240000',
      children: [
        {
          label: '大学',
          value: '241000'
        },
        {
          label: '中学',
          value: '241100'
        },
        {
          label: '小学',
          value: '241200'
        },
        {
          label: '幼儿园',
          value: '241300'
        },
        {
          label: '培训',
          value: '241500',
          children: [
            {
              label: '幼儿教育',
              value: '241510'
            },
            {
              label: '外语培训',
              value: '241511'
            },
            {
              label: '音乐舞蹈',
              value: '241512'
            },
            {
              label: '升学辅导',
              value: '241513'
            },
            {
              label: '美术培训',
              value: '241514'
            },
            {
              label: '体育培训',
              value: '241515'
            },
          ]
        },
        {
          label: '职业技术学校',
          value: '241600'
        },
        {
          label: '成人教育',
          value: '241700'
        },
        {
          label: '教育学校附属',
          value: '248000'
        },
        {
          label: '其它教育学校',
          value: '249900'
        },
      ]
    },
    {
      label: '银行金融',
      value: '250000',
      children: [
        {
          label: '银行',
          value: '251000'
        },
        {
          label: '自动提款机',
          value: '251100'
        },
        {
          label: '保险公司',
          value: '251200'
        },
        {
          label: '证券公司',
          value: '251300'
        },
        {
          label: '财务公司',
          value: '251400'
        },
        {
          label: '银行金融场所附属',
          value: '258000'
        },
        {
          label: '其它银行金融',
          value: '259900'
        },
      ]
    },
    {
      label: '地名地址',
      value: '260000',
      children: [
        {
          label: '交通地名',
          value: '261000'
        },
        {
          label: '地名地址信息',
          value: '261100'
        },
        {
          label: '道路名',
          value: '261200'
        },
        {
          label: '自然地名',
          value: '261300',
          children: [
            {
              label: '山',
              value: '261310'
            },
            {
              label: '岛屿',
              value: '261311'
            },
            {
              label: '河流',
              value: '261312'
            },
            {
              label: '海湾海峡',
              value: '261313'
            },
            {
              label: '湖泊',
              value: '261314'
            },
            {
              label: '其它自然地名',
              value: '261399'
            },
          ]
        },
        {
          label: '行政地名',
          value: '261400'
        },
        {
          label: '门牌信息',
          value: '261500'
        },
        {
          label: '热点区域',
          value: '261600',
          children: [
            {
              label: '交通类',
              value: '261610'
            },
            {
              label: 'POI类',
              value: '261611'
            },
            {
              label: '行政类',
              value: '261612'
            },
            {
              label: '商圈类',
              value: '261613'
            },
            {
              label: '其它热点区域',
              value: '261699'
            },
          ]
        },
        {
          label: '其它地名地址',
          value: '269900'
        },
      ]
    },
    {
      label: '基础设施',
      value: '270000',
      children: [
        {
          label: '交通设施',
          value: '271000',
          children: [
            {
              label: '交通服务相关',
              value: '271010'
            },
            {
              label: '公交车站',
              value: '271013'
            },
            {
              label: '地铁站',
              value: '271014'
            },
            {
              label: '港口码头',
              value: '271015'
            },
            {
              label: '火车站',
              value: '271016'
            },
            {
              label: '轻轨站',
              value: '271017'
            },
            {
              label: '过境口岸',
              value: '271018'
            },
            {
              label: '长途汽车站',
              value: '271019'
            },
            {
              label: '飞机场',
              value: '271020'
            },
            {
              label: '公交线路',
              value: '271021'
            },
            {
              label: '地铁线路',
              value: '271022'
            },
            {
              label: '班车线路',
              value: '271060'
            },
            {
              label: '班车站点',
              value: '271061'
            },
            {
              label: '地铁站出入口',
              value: '271030'
            },
            {
              label: '其它交通设施',
              value: '271099'
            },
          ]
        },
        {
          label: '机场附属',
          value: '271300',
          children: [
            {
              label: '登机口',
              value: '271310'
            },
            {
              label: '候机厅',
              value: '271311'
            },
            {
              label: '出发',
              value: '271312'
            },
            {
              label: '到达',
              value: '271313'
            },
            {
              label: '值机柜台',
              value: '271314'
            },
            {
              label: '机场中转服务柜台',
              value: '271315'
            },
            {
              label: '出入境柜台',
              value: '271316'
            },
            {
              label: '航空公司服务柜台',
              value: '271317'
            },
            {
              label: '机场巴士站',
              value: '271318'
            },
            {
              label: '到达口',
              value: '271319'
            },
  
          ]
        },
        {
          label: '火车站附属',
          value: '271400',
          children: [
            {
              label: '候车厅',
              value: '271410'
            },
            {
              label: '检票口',
              value: '271411'
            },
            {
              label: '出站口',
              value: '271412'
            },
            {
              label: '进站口',
              value: '271413'
            },
            {
              label: '火车站台',
              value: '271414'
            },
          ]
        },
        {
          label: '其它交通设施附属',
          value: '271500',
          children: [
            {
              label: '行李服务',
              value: '271510'
            },
            {
              label: '地铁设施',
              value: '271511'
            },
            {
              label: '地铁站台',
              value: '271512'
            },
            {
              label: '交通停靠点',
              value: '271513'
            },
            {
              label: '票务服务',
              value: '271514'
            },
          ]
        },
        {
          label: '公共设施',
          value: '271100',
          children: [
            {
              label: '公共厕所',
              value: '271110'
            },
            {
              label: '男洗手间',
              value: '271114'
            },
            {
              label: '女洗手间',
              value: '271115'
            },
            {
              label: '无障碍洗手间',
              value: '271116'
            },
            {
              label: '座椅设施',
              value: '271117'
            },
            {
              label: '公用电话',
              value: '271112'
            },
            {
              label: '紧急避难场所',
              value: '271113'
            },
            {
              label: '其它公共设施',
              value: '271199'
            },
          ]
        },
        {
          label: '道路附属',
          value: '271200',
          children: [
            {
              label: '收费站',
              value: '271210'
            },
            {
              label: '服务区',
              value: '271211'
            },
            {
              label: '道路出入口',
              value: '271212'
            },
            {
              label: '路口',
              value: '271213'
            },
            {
              label: '桥',
              value: '271214'
            },
            {
              label: '其它道路附属',
              value: '271299'
            },
          ]
        },
        {
          label: '其它基础设施',
          value: '279900',
        },
      ]
    },
    {
      label: '房产小区',
      value: '280000',
      children: [
        {
          label: '住宅区',
          value: '281000',
          children: [
            {
              label: '住宅小区',
              value: '281010'
            },
            {
              label: '别墅',
              value: '281011'
            },
            {
              label: '宿舍',
              value: '281012'
            },
            {
              label: '社区中心',
              value: '281013'
            },
            {
              label: '其它住宅区',
              value: '281099'
            },
          ]
        },
        {
          label: '产业园区',
          value: '281100'
        },
        {
          label: '商务楼宇',
          value: '281200'
        },
        {
          label: '商务楼宇设施',
          value: '281300',
          children: [
            {
              label: '会议室',
              value: '281310'
            },
            {
              label: '办公室',
              value: '281311'
            },
            {
              label: '前台接待',
              value: '281312'
            },
            {
              label: '阅览室',
              value: '281313'
            },
            {
              label: '工位',
              value: '281314'
            },
            {
              label: '讨论区',
              value: '281315'
            },
            {
              label: '培训室',
              value: '281316'
            },
            {
              label: '经理室',
              value: '281317'
            },
            {
              label: '文印室',
              value: '281318'
            },
            {
              label: '电话间',
              value: '281319'
            },
            {
              label: '办公区',
              value: '281320'
            },
          ]
        },
        {
          label: '房产小区附属',
          value: '288000'
        },
        {
          label: '其它房产小区',
          value: '289900'
        },
      ]
    },
    {
      label: '室内及附属设施',
      value: '800000',
      children: [
        {
          label: '通行设施类',
          value: '801000',
          children: [
            {
              label: '门/出入口',
              value: '801010'
            },
            {
              label: '楼梯',
              value: '801011'
            },
            {
              label: '电梯',
              value: '801012'
            },
            {
              label: '内部门',
              value: '801013'
            },
            {
              label: '店铺门',
              value: '801014'
            },
            {
              label: '店铺辅助门',
              value: '801027'
            },
            {
              label: '正门',
              value: '801015'
            },
            {
              label: '底商外部门',
              value: '801016'
            },
            {
              label: '外部门',
              value: '801017'
            },
            {
              label: '外部辅助门',
              value: '801025'
            },
            {
              label: '其它外部门',
              value: '801026'
            },
            {
              label: '停车场出入口',
              value: '801018'
            },
            {
              label: '停车场入口',
              value: '801019'
            },
            {
              label: '停车场出口',
              value: '801020'
            },
            {
              label: '扶梯',
              value: '801021'
            },
            {
              label: '货梯（直梯）',
              value: '801022'
            },
            {
              label: '客梯（直梯）',
              value: '801023'
            },
            {
              label: '自动步道',
              value: '801024'
            },
            {
              label: '停车场楼层间出口',
              value: '801028'
            },
            {
              label: '停车场楼层间入口',
              value: '801029'
            },
            {
              label: '停车场楼层间出入口',
              value: '801030'
            },
            {
              label: '停车场闸机',
              value: '801031'
            },
            {
              label: '电梯间门/出入口',
              value: '801032'
            },
            {
              label: '其它通行设施类',
              value: '801099'
            },
  
          ]
        },
        {
          label: '其它室内及附属设施',
          value: '809900',
          children: [
            {
              label: '辅助分区',
              value: '809910'
            },
            {
              label: '受限区域',
              value: '809911'
            },
            {
              label: '封闭区域',
              value: '809912'
            },
            {
              label: '中空区域',
              value: '809913'
            },
            {
              label: '空置单元',
              value: '809914'
            },
            {
              label: '扶梯辅助面',
              value: '809915'
            },
            {
              label: '景观设施',
              value: '809916'
            },
            {
              label: '电梯厅区域',
              value: '809917'
            },
            {
              label: '淋浴更衣',
              value: '809918'
            },
            {
              label: '楼层边界点',
              value: '809919'
            },
            {
              label: '分区主点',
              value: '809920'
            },
          ]
        },
      ]
    },
    {
      label: '其它',
      value: '990000'
    }
  ];